import api from './api'

export default {
  async listarProdutos(params = {}) {
    const paramsComEmpresa = { ...params, empresaId: 3 }
    // Rota padrão: lista apenas produtos ativos (usada no catálogo, etc.)
    const response = await api.get('/produtos', { params: paramsComEmpresa })
    return response.data
  },

  async listarProdutosComInativosPorEmpresa(empresaId = 3, params = {}) {
    const paramsComEmpresa = { ...params, empresaId }
    // Rota específica para tela de cadastro: traz ativos + inativos por empresa
    const response = await api.get(`/produtos/empresa/${empresaId}/todos`, {
      params: paramsComEmpresa
    })
    return response.data
  },

  async listarDestaques() {
    const response = await api.get('/produtos/destaques', { params: { empresaId: 3 } })
    return response.data
  },

  async buscarProduto(id) {
    const response = await api.get(`/produtos/${id}`, { params: { empresaId: 3 } })
    return response.data
  },

  async criarProduto(formData) {
    const response = await api.post('/produtos', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  },

  async criarProdutoJson(data) {
    const dataComEmpresa = { ...data, empresaId: 3 }
    const response = await api.post('/produtos', dataComEmpresa)
    return response.data
  },

  // Atualiza apenas os dados do produto (JSON, sem imagem)
  async atualizarProduto(id, data) {
    const dataComEmpresa = { ...data, empresaId: 3 }
    const response = await api.put(`/produtos/${id}`, dataComEmpresa)
    return response.data
  },

  // Atualiza apenas a imagem do produto
  async atualizarImagem(id, file) {
    const formData = new FormData()
    formData.append('file', file)

    const response = await api.post(`/produtos/${id}/imagem`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }
}

